import React from 'react';

import { Colors, Link, Paper, Text } from 'library';
import Header from '../Header';
import Paragraph from '../Paragraph';
import usePublicSessionTracking, { PublicSessionEventType } from 'parent-portal/shared/PublicSessionTracking';
import { MarketingSiteUrl } from 'environmentVariables';

const aboutUsLink = `${MarketingSiteUrl}/about-us`;

export default function AmbassadorAbout() {
    const { trackSession } = usePublicSessionTracking('Ambassador About');

    function goToAboutUs() {
        trackSession('NAVIGATE_FROM', 'Went to about us page', PublicSessionEventType.User);
        window.open(aboutUsLink);
    }

    return (
        <>
            <Header>About Tandem</Header>
            <Paragraph>
                Tandem was locally founded by 3 young women in Columbus, Ohio to empower care providers to easily manage
                their skills and offerings in one place for free. <Link onClick={goToAboutUs}>Read our story</Link>.
            </Paragraph>
            <Header>What is a Tandem ambassador?</Header>
            <Paragraph>
                As an ambassador, you leverage your network to get new people to sign up for Tandem. Tandem provides
                tools, marketing material, custom tracking resources, and extensive education on different ways to
                leverage social media and manual outreach to bring people to Tandem.
            </Paragraph>
            <Header>What do I get as an ambassador?</Header>
            <Paragraph>
                You will receive compensation for each provider that joins Tandem, real-world marketing experience, and
                you will be supporting a small women-led company as they empower all care providers to keep 100% of
                their earnings.{' '}
            </Paragraph>
            <Header>Compensation</Header>
            <Paragraph>
                Earn up to $25 for each person who signs up using your unique code.
                <br />
                <br />
                Your pay breakdown, determined by what people are looking for when they join Tandem:
                <br />
                <br />
                <Paper style={{ marginBottom: 30, backgroundColor: Colors.lightGreen }}>
                    <Text textStyle={{ fontWeight: 'bolder' }} variant="h2">
                        Looking to Hire
                    </Text>
                    <Text variant="body2">
                        <br />• $25 for each person who joins to post jobs, upon approval of each person from us.
                    </Text>
                </Paper>
                <Paper style={{ backgroundColor: Colors.lightGreen }}>
                    <Text textStyle={{ fontWeight: 'bolder' }} variant="h2">
                        Looking for Jobs
                    </Text>
                    <Text variant="body2">
                        <br />• $15 for each person who joins to find jobs and earn money.
                        <br />• $10 more when they get hired for their first job.
                    </Text>
                </Paper>
                <br />
                <br />
                There's no agreement to sign, and you can start and stop recruiting people to join Tandem whenever you
                like.
            </Paragraph>
        </>
    );
}
